import Component from "@base/js/component";
import Drawer from "@components/drawer/drawer";

export default class Accordion extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".accordion";

  // Defines children that needs to be queried as part of this component
  static children = {
    // body: ".accordion__body" // Queries a single element
    // items: [".accordion__items"] // Queries a an array of elements
  };

  // Defines sub components that needs to be queried as part of this component
  static members = {
    drawers: [Drawer],
  };

  // Defines event handlers to attach to children
  eventHandlers = {
    // body: {
    //  click: this.onBodyClick // Attaches onBodyClick method to this.children.body
    // }
  };

  // Will be called upon component instantiation
  afterInit() {
    // this.members.drawers.forEach((drawer, index) => {
    //   // Add beforeExpand handler for each drawer
    //   drawer.beforeExpand(() => this.onDrawerBeforeExpand(index));
    // });
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
Accordion.init();
